import React from 'react';

export const SectionActiveContext = React.createContext<boolean>(false);

function useSectionActive() {
  return React.useContext(SectionActiveContext);
}

export default useSectionActive;
